/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../store/store.js';
import { getAllUsers } from '../api/user.js';
import { getAllBadges } from '../data/badgeData.js';
import { Avatar } from '../components/avatar/Avatar.jsx';
import { FaFire } from "react-icons/fa";
import ClipLoader from 'react-spinners/ClipLoader';

export default function Leaderboard() {
    const badges = getAllBadges();
    const currentUser =  useAuthStore(store => store.user);
    const [topTenUsers, setTopTenUsers] = useState([]);

    const allUsersQuery = useQuery({
        queryKey: ['allUsers'],
        queryFn: () => getAllUsers(),
    });

    useEffect(() => {
        if (allUsersQuery.isSuccess) {
            setTopTenUsers(getTopTenUsers(allUsersQuery.data));
        }
    }, [allUsersQuery.isSuccess])

    const getTopTenUsers = (users) => {
        const sortedUsers = Object.values(users).sort((a, b) => b.streaks - a.streaks);
        const topTenUsers = sortedUsers.slice(0, 10);

        return topTenUsers;
    }

    const getUserAvatar = (user) => {
        const avatarColors = user.avatar.colors;
        const avatarStyles = user.avatar.styles;

        // TODO: remove the outer div when we remove bootstrap dependency
        return (
            <div className='w-20 h-20'>
                <Avatar {...avatarColors} {...avatarStyles} width={20} height={20} />
            </div>
        )
    }

    const renderTopThreeUsers = (users) => {
        const topThreeUsers = [
            {
                user: users[1],
                ranking: '2nd',
            },
            {
                user: users[0],
                ranking: '1st',
            },
            {
                user: users[2],
                ranking: '3rd',
            },
        ];

        return (
            <div className='flex w-full gap-2'>
                {topThreeUsers.map(user => (
                    <div 
                        className={`grow flex flex-column bg-white items-center relative gap-2 rounded-xl basis-0`}
                    >
                        {getUserAvatar(user.user)}
                        <p className='w-[70%] break-words text-center m-0'>{user.user.avatarName}</p>
                        <div className='flex w-full justify-center'>
                            {user.user.unlockedBadges.map(badgeId => (
                                <img className='w-10 h-10' src={badges[badgeId].imageUrl}/>
                            ))}
                        </div>
                        <div className='flex items-center mb-4 gap-[2px]'>
                            <FaFire className='fill-red'/>         
                            <div>{user.user.streaks}</div>
                        </div>
                        <div className='absolute bottom-[-0.8rem] left-1/2 transform -translate-x-1/2 font-bold text-xl'>{user.ranking}</div>
                    </div>
                ))}
            </div>
        );
    }

    const renderRemainingUsers = (users) => {
        const isUserTopTen = users.some((user) => user.uid === currentUser.uid);

        if (!isUserTopTen) {
            const currentUserProfile = allUsersQuery.data[currentUser.uid];
            users.push({
                uid: currentUserProfile.uid,
                avatarName: currentUserProfile.avatarName,
                avatar: currentUserProfile.avatar,
                streaks: currentUserProfile.streaks,
                unlockedBadges: currentUserProfile.unlockedBadges,
            })
        }

        const remainingUsers = users.slice(3, users.length);

        return (
            <div className='flex flex-col w-full'>
                {remainingUsers.map(user => {
                    const isCurrentUser = currentUser.uid === user.uid;
                    
                    return (
                        <div className='flex flex-row w-full items-center mt-4 bg-white rounded-xl justify-between'>
                            <div className='flex items-center gap-4'>
                                {getUserAvatar(user)}
                                <div className='flex min-w-[4rem]'>
                                    {user.unlockedBadges.map(badgeId => (
                                        <img className='w-10 h-10' src={badges[badgeId].imageUrl}/>
                                    ))}
                                </div>
                            </div>
                            <p className={`ml-[-3rem] mb-0 ${isCurrentUser ? 'font-bold' : ''}`}>{user.avatarName} {isCurrentUser ? '(YOU)' : ''}</p>
                            <div className='flex items-center gap-[2px] pr-10'>
                                <FaFire className='fill-red'/>         
                                <div>{user.streaks}</div>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }

    if (allUsersQuery.isLoading) {
        return (
            <div className='flex items-center justify-center min-h-[90%]'>
                <ClipLoader
                    loading={allUsersQuery.isLoading}
                    size={100}
                    aria-label='Loading Spinner'
                />
            </div>
        )
    }

    if (allUsersQuery.isError || allUsersQuery.data === null) {
        return;
    }

    return (
        <div className='flex flex-col p-4 items-center'>
            <div className='w-full'>
                <h1 className='text-bold text-xl mb-8 text-center'>Leaderboard</h1>
                {topTenUsers.length > 0 ? renderTopThreeUsers(topTenUsers) : null}
                {topTenUsers.length > 0 ? renderRemainingUsers(topTenUsers) : null}
            </div>
        </div>
    );
};
